import { jsx } from 'react/jsx-runtime';
import { createIcon } from '@chakra-ui/react';

const MinusIcon = createIcon({
  displayName: "MinusIcon",
  path: /* @__PURE__ */ jsx("g", { fill: "currentColor", children: /* @__PURE__ */ jsx("rect", { height: "4", width: "20", x: "2", y: "10" }) })
});

export { MinusIcon };
